import React from "react";
import OpenAccount from "../OpenAccounts";
import Hero from "./Hero";
import Brokerage from "./Brokerage";


function PricingPage() {
  return (
    <>
      <Hero />
      <OpenAccount />
      <Brokerage />
    </>
  );
}

export default PricingPage;
